import { IUser, IUserMini, IUserMiniWithRole } from 'Src/ng2/shared/typings/interfaces/user.interface';
import { TValidPartnerTypes } from 'Src/ng2/shared/typings/interfaces/partner.interface';

export function userCate(user: IUser | IUserMini | IUserMiniWithRole, partnerType: TValidPartnerTypes = 'school') {
  return ({ school: schoolHandler, shelter: shelterHandler }) => {
    let res = null;
    switch (partnerType) {
      case 'school':
        res = schoolHandler(user);
        break;
      case 'shelter':
        res = shelterHandler(user);
      default:
        break;
    }
    return res;
  };
}
